/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../../action';
import * as c from '../../constant';

function CreateModal({
  formData,
  createVeterinaryFees,
  getNewOtherFeesList,
  history,
  getSingleNewOtherFees,
  getVeterinaryCalculationList,
  creating,
  ordinanceRevisionId,
  newOtherFeesId,
  createRichTextEditor,
  draftToHtml,
  convertToRaw,
}) {
  const setModal = useContext(ModalContext);
  const [data, setData] = useState({
    veterinary_registration: '',
    amount: '',
  });

  const validateForm = useFormValidator(data, {
    veterinary_registration: 'required',
    amount: 'required',
  });

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...data,
      ...formData,
      detail:
        draftToHtml(
          convertToRaw(
            _.get(formData, 'detail')
              ? _.get(formData, 'detail').getCurrentContent()
              : ''
          )
        ) || '',
    };

    createVeterinaryFees(newOtherFeesId, args, () => {
      setModal({ isOpen: false });
      getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
      getSingleNewOtherFees(newOtherFeesId);
      getVeterinaryCalculationList(newOtherFeesId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(data).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Veterinary Registration:{' '}
              {validateForm.renderMessage('veterinary_registration')}
            </label>
            <input
              className="form-control"
              type="text"
              name="veterinary_registration"
              onChange={onChange}
              value={_.get(data, 'veterinary_registration')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control"
              type="text"
              name="amount"
              onChange={onChange}
              value={_.get(data, 'amount')}
            />
          </div>
          <div className="col-12 form-group">
            {createRichTextEditor(
              { key: 'detail', label: 'Detail:' },
              { required: true, minLength: 3, wrapperClassName: 'border' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  createVeterinaryFees: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getVeterinaryCalculationList: PropTypes.instanceOf(Function).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_VETERINARY_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
